import { render, staticRenderFns } from "./AverageAmount.vue?vue&type=template&id=bfdcea88&scoped=true"
import script from "./AverageAmount.vue?vue&type=script&lang=js"
export * from "./AverageAmount.vue?vue&type=script&lang=js"
import style0 from "./AverageAmount.vue?vue&type=style&index=0&id=bfdcea88&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdcea88",
  null
  
)

export default component.exports